import service from '@/utils/server';

const modName='/bd/tracking/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};
//初始化更新对象
export const initUpdate = data => {
  return service({
    url: modName + 'initUpdate/' + data,
    method: 'post',
    data
  });
};
export const initOrderNo = data => {
  return service({
    url: modName + 'orderStatus/'+data,
    method: 'post',
  });
};
export const initMivDate = data => {
  return service({
    url: modName + 'orderMiv/'+data,
    method: 'post',
  });
};

//模板下载
export const downtemplate = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'template/' + data.templateName,
    method: 'post',
    data
  });
};
//导出
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};

  //特殊订单导入
  export const importOrder = data => {
    let config = {
      responseType: "blob",
      timeout: 500000, // 请求超时时间
      headers: {
        "Content-Type": "multipart/form-data"
      },
    };
    return service({
      ...config,
      url: modName + 'importOrder',
      method: 'post',
      data
    });
  };

//订单修改信息导入
export const updateOrder = data => {
  let config = {
    responseType: "blob",
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    },
  };
  return service({
    ...config,
    url: modName + 'updateOrderInformation',
    method: 'post',
    data
  });
};

//rePush
export const rePush = data => {
  return service({
    url: modName + 'rePush/'+data,
    method: 'post'
  });
};

//rePushBatch
export const rePushBatch = data => {
  return service({
    url: modName + 'rePushBatch',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/toBTracking/tracking/api/index.js